module.exports = __webpack_public_path__ + "img/logo-lithos.841f6fe0.svg";